import { Injectable, Injector, Inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError, switchMap } from 'rxjs/operators';
import { RcAuthService } from './rc-auth.service';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(@Inject('ENVIRONMENT') private environment: any, private injector: Injector, private router: Router) {}
    inflightAuthRequest: Observable<string> = null;
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.environment.addAuthorization) { // If not auth module skip that interceptor
          return next.handle(request);
        }
        // add authorization header with jwt token if available
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.access_Token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.access_Token}`
                }
            });
        }
        const authService = this.injector.get(RcAuthService);
        return next.handle(request).pipe(

            catchError((error) => {
              // checks if a url is to an admin api or not
              if (error.status === 401) {
                // check if the response is from the token refresh end point
                const isFromRefreshTokenEndpoint = !!error.headers.get(
                  'unableToRefreshToken'
                );
                if (isFromRefreshTokenEndpoint) {
                  authService.logout();
                  this.router.navigate(['/']);
                  return throwError(error);
                }
                if (!this.inflightAuthRequest) {
                  this.inflightAuthRequest = authService.refreshToken();
                  if (!this.inflightAuthRequest) {
                    // remove existing tokens
                    authService.logout();
                    this.router.navigate(['/']);
                    return throwError(error);
                  }
                }
                return this.inflightAuthRequest.pipe(
                  switchMap(() => {
                    // unset inflight request
                    this.inflightAuthRequest = null;
                    // clone the original request
                    const currentUserRes = JSON.parse(localStorage.getItem('currentUser'));
                    if (!currentUserRes) {
                        return;
                    }
                    const authReqRepeat = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${currentUserRes.access_Token}`
                        }
                    });
                    // resend the request
                    return next.handle(authReqRepeat);
                  })
                );
              } else {
                return throwError(error);
              }
            })
          ) as any;
    }
}
